import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { IncidentEntryProvider, useIncidents } from "./IncidentEntryContext";
import IncidentsList from "./IncidentsList";
import EditIncidentForm from "./EditIncidentForm";

const ErrorDialog = () => {
  const { errorDialog, setErrorDialog } = useIncidents();

  const handleClose = () => {
    setErrorDialog({ open: false, title: "", message: "" });
  };

  return (
    <Dialog
      open={errorDialog.open}
      onClose={handleClose}
      aria-labelledby="error-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="error-dialog-title">{errorDialog.title}</DialogTitle>
      <DialogContent>
        <Typography>{errorDialog.message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const IncidentEntryPage = () => {
  return (
    <IncidentEntryProvider>
      <IncidentsList />
      <EditIncidentForm />
      <ErrorDialog />
      {/* <IncidentEntryList/> */}
      {/* <IncidentEntryForm/> */}
    </IncidentEntryProvider>
  );
};

export default IncidentEntryPage;
